import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Dialog, DialogContent } from '../components/ui/dialog';



function CataloguePage() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiClient.get(`/products`);
        setProducts(response.data);
      } catch (err) {
        setError('Failed to load products');
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <div className="container mx-auto px-4 py-12">Loading products...</div>;
  if (error) return <div className="container mx-auto px-4 py-12 text-red-500">{error}</div>;

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-12">Our Catalogue</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map(product => (
          <Card key={product.product_id} className="cursor-pointer" onClick={() => setSelectedProduct(product)}>
            <CardContent className="p-4">
              {product.image_url && (
                <img 
                  src={product.image_url?.startsWith('http') ? product.image_url : `/api${product.image_url}`}
                  alt={product.name} 
                  className="w-full h-48 object-cover mb-4 rounded" 
                />
              )}
              <Badge className="mb-2">{product.brand}</Badge>
              <h3 className="font-semibold text-lg mb-2">{product.name}</h3>
              <p className="text-gray-600 mb-2">{product.short_description}</p>
              <p className="text-xl font-bold text-yellow-600">₹{product.price}</p>
            </CardContent>
          </Card>
        ))}
      </div>
      <Dialog open={!!selectedProduct} onOpenChange={() => setSelectedProduct(null)}>
        <DialogContent>
          {selectedProduct && (
            <>
              {selectedProduct.image_url && (
                <img 
                  src={product.image_url?.startsWith('http') ? Selectedproduct.image_url : `/api${Selectedproduct.image_url}`} 
                  alt={selectedProduct.name} 
                  className="w-full h-64 object-cover mb-4 rounded" 
                />
              )}
              <h2 className="text-2xl font-bold mb-2">{selectedProduct.name}</h2>
              <Badge className="mb-4">{selectedProduct.brand}</Badge>
              <p className="text-gray-600">{selectedProduct.long_description}</p>
              <p className="text-xl font-bold text-yellow-600 mt-4">₹{selectedProduct.price}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CataloguePage;